var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OvDocuments',{attrs:{"title":_vm.isPrivateFlow
      ? `Ladda upp filer för ${_vm.secondaryTenantDisplayName}`
      : 'Ladda upp filer för övertagaren',"computed-documents-groups":_vm.computedDocumentsGroups,"category-type":"transferee"}})
}
var staticRenderFns = []

export { render, staticRenderFns }